(function () {
  'use strict';

  if (window.__vmnlExpressSyncInstalled) return;
  window.__vmnlExpressSyncInstalled = true;

  const nativeFetch = window.fetch.bind(window);
  const INTERNAL_HEADER = 'X-VMNL-Internal';
  const EXPRESS_VARIANTS = {
    '50x75': { NONE: 54961174708562, VLAG5: 54961174741330, VLAG10: 54961174774098, VLAG15: 54961174806866, WK10: 54961174839634, WK20: 54961174872402 },
    '70x100': { NONE: 54961174905170, VLAG5: 54961174937938, VLAG10: 54961174970706, VLAG15: 54961175003474, WK10: 54961175036242, WK20: 54961175069010 },
    '100x150': { NONE: 54961175101778, VLAG5: 54961175134546, VLAG10: 54961175167314, VLAG15: 54961175200082, WK10: 54961175232850, WK20: 54961175265618 },
    '120x180': { NONE: 54961175298386, VLAG5: 54961175331154, VLAG10: 54961175363922, VLAG15: 54961175396690, WK10: 54961175429458, WK20: 54961175462226 },
    '150x225': { NONE: 54961175494994, VLAG5: 54961175527762, VLAG10: 54961175560530, VLAG15: 54961175593298, WK10: 54961175626066, WK20: 54961175658834 },
    '200x300': { NONE: 54961175691602, VLAG5: 54961175724370, VLAG10: 54961175757138, VLAG15: 54961175789906, WK10: 54961175822674, WK20: 54961175855442 },
    '225x350': { NONE: 54961175888210, VLAG5: 54961175920978, VLAG10: 54961175953746, VLAG15: 54961175986514, WK10: 54961176019282, WK20: 54961176052050 }
  };

  function requestUrl(input) {
    return typeof input === 'string' ? input : (input && input.url) || '';
  }

  function isInternal(init) {
    const headers = init && init.headers;
    if (!headers) return false;
    if (typeof Headers !== 'undefined' && headers instanceof Headers) {
      return headers.get(INTERNAL_HEADER) === '1';
    }
    return headers[INTERNAL_HEADER] === '1' || headers[INTERNAL_HEADER.toLowerCase()] === '1';
  }

  function jsonHeaders() {
    return {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      [INTERNAL_HEADER]: '1'
    };
  }

  function newLinkId() {
    return 'vmnl-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 9);
  }

  function normalizeSize(value) {
    if (!value) return null;
    const match = String(value).toLowerCase().replace(/\s+/g, '').match(/(50x75|70x100|100x150|120x180|150x225|200x300|225x350)/);
    return match ? match[1] : null;
  }

  function currentVariant() {
    const variantInput = document.getElementById('product-variant-id');
    const productData = document.querySelector('[data-product-id]');
    if (!variantInput || !productData) return null;

    try {
      const product = JSON.parse(productData.textContent);
      return (product.variants || []).find(function (variant) {
        return String(variant.id) === String(variantInput.value);
      }) || null;
    } catch (error) {
      return null;
    }
  }

  function sizeFromVariant(variant) {
    if (!variant) return null;
    const values = [variant.title].concat(variant.options || []);
    for (const value of values) {
      const size = normalizeSize(value);
      if (size) return size;
    }
    return null;
  }

  function expressIsSelected() {
    const value = localStorage.getItem('selectedDeliveryType') || '';
    return value === 'Express verzending' || value === 'Express productie';
  }

  function hasExpressProperty(item) {
    const properties = (item && item.properties) || {};
    return Object.keys(properties).some(function (key) {
      return /verzending|levering|productie/i.test(key) && /express|spoed/i.test(String(properties[key] || ''));
    });
  }

  function isSystemLine(item) {
    return item && item.properties && item.properties._vmnl_system_line === 'express-production';
  }

  function isNativeMergedLine(item) {
    return item && item.properties && item.properties._vmnl_express_merged === 'true';
  }

  function discountTier(item) {
    if (!item) return 'NONE';
    if (window.VMNL_NATIVE_PRICING_ENABLED === true) return 'NONE';

    const isWimpel = /wimpel/i.test(String(item.product_title || item.title || ''));
    const quantity = Math.max(0, Number(item.quantity) || 0);

    if (!isWimpel) {
      if (quantity >= 4) return 'VLAG15';
      if (quantity >= 3) return 'VLAG10';
      if (quantity >= 2) return 'VLAG5';
      return 'NONE';
    }

    const original = Number(item.original_price || item.price || 0);
    const finalPrice = Number(item.final_price || item.discounted_price || item.price || 0);
    if (!original || finalPrice >= original) return 'NONE';

    const percentage = Math.round(((original - finalPrice) / original) * 100);
    if (percentage >= 18) return 'WK20';
    if (percentage >= 9) return 'WK10';
    return 'NONE';
  }

  function expressVariantFor(item) {
    if (!item) return null;
    const size = normalizeSize(item.variant_title || item.title);
    const tier = discountTier(item);
    const variants = size && EXPRESS_VARIANTS[size];
    if (!variants) return null;
    return {
      id: variants[tier] || variants.NONE,
      size: size,
      tier: tier
    };
  }

  function linkedSystemLine(cart, linkId) {
    return (cart.items || []).find(function (item) {
      return isSystemLine(item) && item.properties._vmnl_link_id === linkId;
    }) || null;
  }

  function linkedParentLine(cart, linkId) {
    return (cart.items || []).find(function (item) {
      return !isSystemLine(item) && item.properties && item.properties._vmnl_link_id === linkId;
    }) || null;
  }

  async function getCart() {
    const response = await nativeFetch('/cart.js', { headers: { [INTERNAL_HEADER]: '1' } });
    return response.json();
  }

  async function addExpressLine(target, quantity, linkId) {
    return nativeFetch('/cart/add.js', {
      method: 'POST',
      headers: jsonHeaders(),
      body: JSON.stringify({
        items: [{
          id: target.id,
          quantity: quantity,
          properties: {
            _vmnl_link_id: linkId,
            _vmnl_system_line: 'express-production',
            _vmnl_express_size: target.size,
            _vmnl_discount_tier: target.tier
          }
        }]
      })
    });
  }

  async function changeLine(key, quantity, properties) {
    const body = { id: String(key), quantity: quantity };
    if (properties) body.properties = properties;

    return nativeFetch('/cart/change.js', {
      method: 'POST',
      headers: jsonHeaders(),
      body: JSON.stringify(body)
    });
  }

  async function syncExpressLine(cart, parent) {
    if (!parent || !parent.properties) return false;
    const linkId = parent.properties._vmnl_link_id;
    if (!linkId) return false;

    const system = linkedSystemLine(cart, linkId);

    if (!hasExpressProperty(parent)) {
      if (system) {
        await changeLine(system.key, 0);
        return true;
      }
      return false;
    }

    const target = expressVariantFor(parent);
    if (!target) {
      if (system) {
        await changeLine(system.key, 0);
        return true;
      }
      return false;
    }

    if (system && String(system.variant_id) === String(target.id)) {
      if (system.quantity !== parent.quantity) {
        await changeLine(system.key, parent.quantity);
        return true;
      }
      return false;
    }

    if (system) {
      await changeLine(system.key, 0);
    }

    await addExpressLine(target, parent.quantity, linkId);
    return true;
  }

  async function finalizeCartResponse(payload, linkId) {
    const cart = await getCart();
    const updates = {};
    const parent = linkedParentLine(cart, linkId);
    const system = linkedSystemLine(cart, linkId);

    if (parent) updates[parent.key] = parent.quantity;
    if (system) updates[system.key] = system.quantity;

    const finalPayload = { updates: updates };
    if (payload.sections) finalPayload.sections = payload.sections;
    if (payload.sections_url) finalPayload.sections_url = payload.sections_url;

    return nativeFetch('/cart/update.js', {
      method: 'POST',
      headers: jsonHeaders(),
      body: JSON.stringify(finalPayload)
    });
  }

  async function attachExpressToNewParent(input, init, linkId) {
    const response = await nativeFetch(input, init);
    if (!response.ok) return response;

    try {
      const cart = await getCart();
      const parent = linkedParentLine(cart, linkId);
      if (parent) await syncExpressLine(cart, parent);
    } catch (error) {
      console.warn('[VMNL Express] Express-regel toevoegen mislukte.', error);
    }

    return response;
  }

  async function handleAdd(input, init) {
    const existingBody = init && init.body;
    if (typeof existingBody === 'string') {
      try {
        const existingPayload = JSON.parse(existingBody);
        if (
          Array.isArray(existingPayload.items) &&
          existingPayload.items.some(function (item) {
            return item && item.properties && item.properties._vmnl_system_line === 'express-production';
          })
        ) {
          return nativeFetch(input, init);
        }
      } catch (error) {}
    }

    if (!expressIsSelected()) return nativeFetch(input, init);

    const variant = currentVariant();
    const selectedSize = sizeFromVariant(variant);
    if (!variant || !selectedSize || !EXPRESS_VARIANTS[selectedSize]) return nativeFetch(input, init);

    const linkId = newLinkId();
    const body = init && init.body;

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      if (String(body.get('id')) !== String(variant.id)) return nativeFetch(input, init);
      body.set('properties[_vmnl_link_id]', linkId);
      return attachExpressToNewParent(input, Object.assign({}, init, { body: body }), linkId);
    }

    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      if (String(body.get('id')) !== String(variant.id)) return nativeFetch(input, init);
      body.set('properties[_vmnl_link_id]', linkId);
      return attachExpressToNewParent(input, Object.assign({}, init, { body: body }), linkId);
    }

    if (typeof body === 'string') {
      try {
        const payload = JSON.parse(body);

        if (Array.isArray(payload.items)) {
          const parent = payload.items.find(function (item) {
            return String(item.id) === String(variant.id) && !(item.properties && item.properties._vmnl_system_line);
          });
          if (!parent) return nativeFetch(input, init);

          parent.properties = Object.assign({}, parent.properties || {}, { _vmnl_link_id: linkId });
          return attachExpressToNewParent(input, Object.assign({}, init, { body: JSON.stringify(payload) }), linkId);
        }

        if (String(payload.id) !== String(variant.id)) return nativeFetch(input, init);
        payload.properties = Object.assign({}, payload.properties || {}, { _vmnl_link_id: linkId });
        return attachExpressToNewParent(input, Object.assign({}, init, { body: JSON.stringify(payload) }), linkId);
      } catch (error) {
        return nativeFetch(input, init);
      }
    }

    return nativeFetch(input, init);
  }

  async function handleChange(input, init) {
    const body = init && init.body;
    if (typeof body !== 'string') return nativeFetch(input, init);

    let payload;
    try {
      payload = JSON.parse(body);
    } catch (error) {
      return nativeFetch(input, init);
    }

    const line = parseInt(payload.line, 10);
    if (!line || typeof payload.quantity === 'undefined') return nativeFetch(input, init);

    try {
      const before = await getCart();
      const parentBefore = before.items && before.items[line - 1];
      if (!parentBefore || isSystemLine(parentBefore)) return nativeFetch(input, init);
      if (isNativeMergedLine(parentBefore)) return nativeFetch(input, init);

      const linkId = parentBefore.properties && parentBefore.properties._vmnl_link_id;
      if (!linkId) return nativeFetch(input, init);

      const parentResponse = await nativeFetch(input, init);
      if (!parentResponse.ok) return parentResponse;

      if (Number(payload.quantity) === 0) {
        const afterRemoval = await getCart();
        const system = linkedSystemLine(afterRemoval, linkId);
        if (system) await changeLine(system.key, 0);
        return finalizeCartResponse(payload, linkId);
      }

      const afterParentChange = await getCart();
      const parent = linkedParentLine(afterParentChange, linkId);
      if (parent) await syncExpressLine(afterParentChange, parent);

      return finalizeCartResponse(payload, linkId);
    } catch (error) {
      console.warn('[VMNL Express] Synchroniseren van aantallen mislukte.', error);
      return nativeFetch(input, init);
    }
  }

  window.fetch = function (input, init) {
    const url = requestUrl(input);
    if (isInternal(init)) return nativeFetch(input, init);
    if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(url)) return nativeFetch(input, init || {});
    if (/\/cart\/change\.js(?:\?|$)/.test(url)) return handleChange(input, init || {});
    return nativeFetch(input, init);
  };

  async function repairLinkedLines() {
    if (!window.location.pathname.startsWith('/cart')) return;

    try {
      let cart = await getCart();

      const orphan = (cart.items || []).find(function (item) {
        if (!isSystemLine(item)) return false;
        const linkId = item.properties && item.properties._vmnl_link_id;
        return !linkId || !linkedParentLine(cart, linkId);
      });

      if (orphan) {
        await changeLine(orphan.key, 0);
        window.location.reload();
        return;
      }

      const unlinkedParent = (cart.items || []).find(function (item) {
        return !isSystemLine(item) && !isNativeMergedLine(item) && hasExpressProperty(item) && !(item.properties && item.properties._vmnl_link_id);
      });

      if (unlinkedParent) {
        const linkId = newLinkId();
        const properties = Object.assign({}, unlinkedParent.properties || {}, { _vmnl_link_id: linkId });
        await changeLine(unlinkedParent.key, unlinkedParent.quantity, properties);

        cart = await getCart();
        const parent = linkedParentLine(cart, linkId);
        if (parent) await syncExpressLine(cart, parent);

        window.location.reload();
        return;
      }

      for (const parent of cart.items || []) {
        if (isSystemLine(parent)) continue;
        if (isNativeMergedLine(parent)) continue;
        if (!(parent.properties && parent.properties._vmnl_link_id)) continue;

        const changed = await syncExpressLine(cart, parent);
        if (changed) {
          window.location.reload();
          return;
        }
      }
    } catch (error) {
      console.warn('[VMNL Express] Cart-herstelcontrole mislukte.', error);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repairLinkedLines, { once: true });
  } else {
    repairLinkedLines();
  }
})();
